var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 29,
    viewBox: "0 0 2 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 29C0.734784 29 0.480429 28.8909 0.292892 28.6966C0.105356 28.5024 0 28.239 0 27.9643V1.03571C0 0.761026 0.105356 0.497588 0.292892 0.303354C0.480429 0.10912 0.734784 0 1 0C1.26522 0 1.51957 0.10912 1.70711 0.303354C1.89464 0.497588 2 0.761026 2 1.03571V27.9643C2 28.239 1.89464 28.5024 1.70711 28.6966C1.51957 28.8909 1.26522 29 1 29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalVector);
export default __webpack_public_path__ + "static/media/vertical-vector.af4dfcb74eb9e2f309c39a3a9cda0eb1.svg";
export { ForwardRef as ReactComponent };